import axiosClient from './axiosClient';

const API_URL = "/price-request";

/**
 * Interface for price request data
 */
export interface PriceRequestData {
    email: string;
    serviceType: string;
}

/**
 * Sends a price request to the server
 * @param data - Price request data containing email and service name
 * @returns Promise with the response data
 */
export const sendPriceRequest = async (data: PriceRequestData) => {
    const response = await axiosClient.post(API_URL, data);
    return response.data;
}; 